import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Colaborador } from 'src/app/models/colaborador';
import { ColaboradorPedido } from 'src/app/models/colaborador-pedido';
import { CollaboratorFilter } from 'src/app/models/collaborator-filter';
import { CollaboratorsGroupPaged, GroupColaborator, GroupColaboratorUpdate, GroupCollaboratorAlter, GroupCollaboratorDelete } from 'src/app/models/group';
import { ResponseBase } from 'src/app/models/response-base';
import { ColaboradorFilterOptions } from 'src/app/shared/helpers/models/colaborador-filter-options';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ColaboratorsGroupService {

   private URL = environment.GATEWAY + 'group/collaboratorsOfGroup';
  // private URL = 'http://af8878d6354674085a29c95ff68310d6-1912565702.us-east-1.elb.amazonaws.com/api/CollaboratorsOfGroup';

  constructor(private http: HttpClient) { }

  getColaborators(groupGuid: string,page: number,limit: number, object: CollaboratorFilter, filters: ColaboradorFilterOptions) {
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');

    let params = new HttpParams();
    // parametros
    params = params.append('hasApp', filters.aplicativo.toString());
    params = params.append('allowSearchByName', filters.permitirBuscarNome.toString());
    params = params.append('allowSearchByDocument', filters.permitirBuscarCPF.toString());
    params = params.append('allowSearchByNameLike', filters.permitirBuscarNomeLike.toString());
    params = params.append('allowSearchByDocumentLike', filters.permitirBuscarCPFLike.toString());
    params = params.append('allowEmptySearch', filters.permitirBuscarVazio.toString());

    return this.http.post<ResponseBase<CollaboratorsGroupPaged>>(`${this.URL}/group/${groupGuid}/page/${page}/limit/${limit}`, object, { headers, params});
  }

  addColaborators(colaborators: GroupColaboratorUpdate) {
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    return this.http.post<ResponseBase<boolean>>(`${this.URL}/create`, colaborators, { headers });
  }

  updateGroup(colaborators: GroupCollaboratorAlter) {
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    return this.http.put<ResponseBase<boolean>>(`${this.URL}/alter-group`, colaborators, { headers });
  }

  removeCollaborator(colaborators: GroupCollaboratorDelete) {
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');

    const options = {
        headers,
        body: colaborators
    };

    return this.http.delete<ResponseBase<boolean>>(`${this.URL}/delete`, options);
  }

  getColaboradoresPedidoFromGrupo(cedenteGuid: string, grupoId: number) {
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    return this.http.get<ResponseBase<Colaborador[]>>(`${this.URL}/cedente/${cedenteGuid}/grupo/${grupoId}`, { headers });
  }

  checkColaboradorTemGrupo(cedenteGuid: string, colaboradorId: number)  {
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    return this.http.get<ResponseBase<boolean>>(`${this.URL}/cedente/${cedenteGuid}/colaborador/${colaboradorId}`, { headers });
  }
  getGrupoColaborador(cedenteGuid: string, colaboradorId: number)  {
    let headers = new HttpHeaders();
    headers = headers.append('Gateway', 'true');
    return this.http.get<ResponseBase<string>>(`${this.URL}/cedente/${cedenteGuid}/colaborador/${colaboradorId}/grupo`, { headers });
  }

}
